import { Component, OnInit } from '@angular/core';
import { ManageTemplateWrapper } from './manage-template-wrapper';
import { Performer } from 'globals/store/performers.data';
import { performerTemplateReselector } from '../../store/reselectors/entity.reselector';
import { ManageWrapperComponent } from 'src/app/modules/manage/manage-wrapper.component';
import { CommonModule } from '@angular/common';
import { ImageUploaderComponent } from '../wrappers/image-uploader.component';
import { JoiInputComponent } from '../joi-input/joi-input.component';
import { ManageSocialLinksComponent } from 'src/app/modules/manage/manage-social.component';
import { ManageContactDetailsComponent } from 'src/app/modules/manage/manage-contact-details.component';

@Component({
    selector: 'manage-template-performer',
    templateUrl: './manage-template-performer.html',
    styleUrls: ['../../modules/manage/manage-dialogs.scss'],
    standalone: true,
    imports: [ManageWrapperComponent, CommonModule, ImageUploaderComponent, JoiInputComponent, ManageSocialLinksComponent, ManageContactDetailsComponent],
})
export class ManageTemplatePerformer extends ManageTemplateWrapper<Performer> implements OnInit {
  _file = 'manage-template-performer'

  ngOnInit() {
    this.clipboardKey = 'performers'
    this.selectProp(performerTemplateReselector, { id: this.data.entityId, accountId: this.data.accountId}, 'entity')
  }

}
